import React from 'react';
import { PersonDetail } from '../../../types/personDetail';
import { Shield, ContactRound, Mails } from 'lucide-react';
import { InfoCard, InfoRow } from '../../shared';

interface PersonSettingsProps {
  personDetail: PersonDetail;
}

export const PersonSettings: React.FC<PersonSettingsProps> = ({ personDetail }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {/* Privacy Settings */}
      <InfoCard title="Privacy Settings" icon={<Shield size={20} />} editable onSave={(data) => console.log('Save privacy', data)}>
        <InfoRow label="Profile Listed" value={personDetail.profileListed} type="boolean" />
        <InfoRow label="Mailing Address Visibility" value="My Friends" />
        <InfoRow label="Home Phone Visibility" value="My Friends and Group Members" />
        <InfoRow label="Mobile Phone Visibility" value="My Friends" />
        <InfoRow label="Birthday Visibility" value="Everyone" />
        <InfoRow label="Anniversary Visibility" value="Everyone" />
      </InfoCard>

      {/* Communication Preferences */}
      <InfoCard title="Communication Preferences" icon={<Mails size={20} />} editable onSave={(data) => console.log('Save communication', data)}>
        <InfoRow label="Receive Email" value={personDetail.receiveEmail} type="boolean" />
        <InfoRow label="New Group Messages" value="Group Default" />
        <InfoRow label="New Group Comments" value="Group Default" />
        <InfoRow label="New Group Digest" value="Group Default" />
        <InfoRow label="New Group SMS" value="Never" />
        <InfoRow label="Mobile Carrier" value={personDetail.mobileCarrier} />
      </InfoCard>

      {/* Account Information */}
      <InfoCard title="Account Information" icon={<ContactRound size={20} />} >
        <InfoRow label="Status" value={personDetail.active ? 'Active' : 'Inactive'} />
        <InfoRow label="Giving Number" value={personDetail.givingId} />
        <InfoRow label="Created Date" value={personDetail.createdDate} />
        <InfoRow label="Last Modified" value={personDetail.modifiedDate} />
        <InfoRow label="Created By" value={personDetail.createdBy} />
        <InfoRow label="Modified By" value={personDetail.modifiedBy} />
      </InfoCard>
    </div>
  );
};
